import React, { useState, useEffect } from 'react';
import './UpdateNotification.css';

function UpdateNotification() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [updateInfo, setUpdateInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    checkForUpdates();
    // Vérifier les mises à jour toutes les 5 minutes
    const interval = setInterval(checkForUpdates, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const checkForUpdates = async () => {
    try {
      // Récupérer la version serveur
      const response = await fetch('/version.json?t=' + Date.now());
      const serverVersion = await response.json();

      // Récupérer la version locale
      const localVersion = localStorage.getItem('app_version');

      console.log('Version locale:', localVersion);
      console.log('Version serveur:', serverVersion.version);

      // Si pas de version locale, la stocker
      if (!localVersion) {
        localStorage.setItem('app_version', serverVersion.version);
        return;
      }

      // Comparer les versions
      if (localVersion !== serverVersion.version) {
        setUpdateInfo(serverVersion);
        setUpdateAvailable(true);
        setDismissed(false);
      }
    } catch (error) {
      console.error('Erreur lors de la vérification des mises à jour:', error);
    }
  };

  const handleUpdate = () => {
    // Mettre à jour la version locale
    if (updateInfo) {
      localStorage.setItem('app_version', updateInfo.version);
    }
    // Recharger la page pour obtenir la nouvelle version
    window.location.reload(true);
  };

  const handleDismiss = () => {
    setDismissed(true);
    // Rappeler dans 30 minutes
    setTimeout(() => {
      setDismissed(false);
    }, 30 * 60 * 1000);
  };

  if (!updateAvailable || dismissed) {
    return null;
  }

  return (
    <div className="update-notification">
      <div className="update-notification-content">
        <div className="update-icon">🔔</div>
        <div className="update-info">
          <h3>Nouvelle mise à jour disponible !</h3>
          <p>{updateInfo?.message || 'Une nouvelle version de l\'application est disponible.'}</p>
          <p className="update-version">Version {updateInfo?.version} ({updateInfo?.date})</p>
        </div>
        <div className="update-actions">
          <button className="btn-update" onClick={handleUpdate}>
            🔄 Mettre à jour
          </button>
          <button className="btn-dismiss" onClick={handleDismiss}>
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateNotification;
